// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_UpdateDiscountInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/update_discount/{order_id}
 *
 * Update the discount on a draft order.
 */
import { registerContract } from './validate'

export interface Orders_UpdateDiscountInput {
discount_type: string
discount_value: number
}

registerContract('Orders_UpdateDiscountInput', {
  discount_type:  { type: 'string',  required: true },
  discount_value: { type: 'number',  required: true },
})
